import { render, staticRenderFns } from "./RiskModelRuleItem.vue?vue&type=template&id=5f295da5&scoped=true&"
import script from "./RiskModelRuleItem.vue?vue&type=script&lang=js&"
export * from "./RiskModelRuleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f295da5",
  null
  
)

export default component.exports